import ModalPanel from '@admin/components/modal_panel'
import Infinite from '@admin/components/infinite'
import Message from '@admin/components/message'
import Img from '@admin/components/html/img'
import PropTypes from 'prop-types'
import React from 'react'

class Contacts extends React.PureComponent {

  static propTypes = {
    _import: PropTypes.object,
    profile: PropTypes.object,
    onBack: PropTypes.func,
    onDone: PropTypes.func,
    onPop: PropTypes.func
  }

  state = {
    contacts: []
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleDone = this._handleDone.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <Infinite { ...this._getInfinite() } />
      </ModalPanel>
    )
  }

  _getImport() {
    const { profile, onDone } = this.props
    return {
      profile,
      onDone
    }
  }

  _getName() {
    const { profile } = this.props
    return profile.service.source_name === 'googlecontacts' ? 'Google Contacts' : 'Outlook 365'
  }

  _getPanel() {
    return {
      title: 't(Preview Contacts)',
      leftItems: [
        { svg: 'chevron_left', handler: this._handleCancel }
      ],
      rightItems: [
        { label: 't(Next)', handler: this._handleDone }
      ]
    }
  }

  _getInfinite() {
    const { profile } = this.props
    const empty = {
      svg: 'user_round',
      title: 't(No Contacts)',
      text: 't(There are no contacts available)'
    }
    return {
      endpoint: `/api/admin/profiles/${profile.id}/contacts`,
      layout: Results,
      empty: <Message {...empty} />
    }
  }

  _handleCancel() {
    this.props.onBack()
  }

  _handleDone() {
    const { _import, profile } = this.props
    this.props.onDone({
      ..._import,
      name: this._getName(),
      service: profile.service.source_name,
      profile_id: profile.id
    })
  }

}

class Results extends React.PureComponent {

  static propTypes = {
    records: PropTypes.array
  }

  render() {
    const { records } = this.props
    return (
      <div className="import-contacts">
        { records.map((contact, index) => (
          <div className="import-contact" key={`contact_${index}`}>
            { contact.photo &&
              <div className="import-contact-avatar">
                <Img src={ contact.photo } />
              </div>
            }
            <div className="import-contact-label">
              <strong>{ contact.first_name } { contact.last_name }</strong><br />
              { contact.email_addresses.length > 0 ? contact.email_addresses[0].address: 'no email' }
            </div>
          </div>
        )) }
      </div>
    )
  }

}

export default Contacts
